const INCREMENT_COUNT = 'sices/overlay/INCREMENT_COUNT';
const DECREMENT_COUNT = 'sices/overlay/DECREMENT_COUNT';

export default {
  INCREMENT_COUNT,
  DECREMENT_COUNT,
};
